import { render, staticRenderFns } from "./Phq4.vue?vue&type=template&id=7a962b7c&scoped=true&"
import script from "./Phq4.vue?vue&type=script&lang=ts&"
export * from "./Phq4.vue?vue&type=script&lang=ts&"
import style0 from "./Phq4.vue?vue&type=style&index=0&id=7a962b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a962b7c",
  null
  
)

export default component.exports